import React, { useEffect, useState } from "react";
import { CommonModal, Spinner } from "../../../../AbstractElements";
import { Row, Col, Form } from "reactstrap";
import { endTrip, onTripAssignChecker } from "../../../../Services/Trip.service";
import { showAlert } from "../../../../Services/Shared.service";
import Success from "../../../../../src/assets/images/success.png"
import LocationSlash from "../../../../../src/assets/images/slash-over-location-pin.jpg"
import { fetchLocation } from "../../../../Services/Booking.service";
import { useController, useForm } from "react-hook-form";
import CustomAutoSuggest from "../../../../CommonElements/CustomAutoSuggest";


const VendorEndTripConformation = ({ Large, title, LargeModaltoggle, tripObj }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [isNotWayPointFound, setIsNotWayPointFound] = useState(false)
  const [isWayPointFound, setIsWayPointFound] = useState(false)

  const {
    register,
    handleSubmit,
    control,
    reset,
    resetField,
    getValues,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      locationAddressDropdown: {},
      locationAddress: "",
    },
  });

  const locationAddressField = useController({
    name: "locationAddressDropdown",
    control,
  }).field;

  const handleLocationSelectChange = (data) => {
    locationAddressField.onChange(data.value);
  };

  useEffect(() => {
    if (locationAddressField.value?.address) {
        setValue("locationAddress", locationAddressField.value?.address);
    } else if (locationAddressField.value) {
        let obj = {
            key: null,
            isAgentApp: true,
            geoApi: true,
            address: locationAddressField.value||null,
            requestSource: "TMS"
        }
        fetchLocation(obj).then((result) => {
            if (result.data.length > 0) {
                locationAddressField.onChange(result.data[0])
            }
        });
    } else {
        setValue("locationAddress", "");
    }
}, [locationAddressField.value]);

  const getAddressData = async (inputValue) => {
    if (inputValue) {
      let obj = {
        key: inputValue,
        isAgentApp: true,
        geoApi: false,
        address: null,
        requestSource: "TMS"
      }
      return fetchLocation(obj).then((result) => {
        if (result.data.length > 0) {
          let data = result.data.map((element) => {
            return {
              value: element,
              label: element?.address ? element.address : element,
            };
          });
          return data;
        }
        return [];
      });
    }
  };


  const onClickConfirm = () => {
    setIsLoading(true)
    let obj = {
      tripId: tripObj.id
    }
    endTrip(obj).then(() => {
      onTripAssignCheckerfunction()
      showAlert("success", "Trip Ended Successfully")
      setIsWayPointFound(true)
      setIsLoading(false)
      LargeModaltoggle()
    }).catch((err) => {
      if (err.response.data.message == "No recent waypoint captured , Please enter the drop location.") {
        setIsNotWayPointFound(true)
        return
      }
      setIsLoading(false)
      LargeModaltoggle()
      showAlert("error", err.response.data.message ? err.response.data.message : "Something went wrong.")
    })
  }
 let onTripAssignCheckerfunction=()=>{
  let obj = {
    tripId: tripObj.id
  }
  onTripAssignChecker(obj).then((res)=>{
    console.log("onTripAssignChecker",res)

  }).catch((err)=>{
    console.log("onTripAssignChecker",err)
  })
 }
  const onClickConfirmWithAddress = () => {
    const values = getValues()
    if (!values.locationAddressDropdown?.lat || !values.locationAddressDropdown?.lat) {
      showAlert("error", "Please select a valid location")
      return;
    }
    let obj = {
      tripId: tripObj.id,
      lat: values.locationAddressDropdown.lat,
      lng: values.locationAddressDropdown.lng,
      destAddress: values.locationAddressDropdown.address,
    }
    endTrip(obj).then(() => {
      showAlert("success", "Trip Ended Successfully")
      setIsLoading(false)
      LargeModaltoggle()
      onTripAssignCheckerfunction()

    }).catch((err) => {
      showAlert("error", err.response.data.message ? err.response.data.message : "Something went wrong.")
    })
  }


  return (
    <CommonModal
      isOpen={Large}
      title={title}
      toggler={LargeModaltoggle}
      size="md"
    >
      <Row className="driver-push-notification">
        {isLoading ? (
          <>
            {!isWayPointFound && !isNotWayPointFound &&
              (<>
                <div className="loader-box" style={{ height: "100px" }}>
                  <Spinner attrSpinner={{ className: "loader-3", style: { width: "50px", height: "50px", borderColor: "#11BF5C", borderBottomColor: "transparent" } }} />
                </div>
                <div style={{ textAlign: "center" }}>Checking the last captured Waypoint.</div>
              </>)}
            {
              isWayPointFound && (
                <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
                  <img src={Success} alt="Success" style={{ width: "70px", height: "70px", marginBottom: "15px" }} />
                  <div >Waypoint found.</div>
                  <div >Trip Ended Successfully.</div>
                </div>
              )
            }
            {
              isNotWayPointFound && (
                <Form onSubmit={handleSubmit(onClickConfirmWithAddress)} style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
                  <img src={LocationSlash} alt="Success" style={{ width: "70px", height: "70px", marginBottom: "15px" }} />
                  <div >Waypoint not found.</div>
                  <div>Enter drop location manually.</div>
                  <div style={{ margin: "15px 0px" }}>
                    <CustomAutoSuggest
                      id={"Location"}
                      handleSelectChange={handleLocationSelectChange}
                      options={getAddressData}
                      placeholder="Enter location"
                      registerName={"locationAddress"}
                      register={register}
                      isClearable={true}
                      setValue={setValue}
                      watch={watch}
                      inputProps={{
                        required: {
                          value: true,
                          message: "Drop Location is required",
                        },
                      }}
                      dependentRegisterName={"locationAddressDropdown"}
                    />
                    <span style={{color: "red"}}>{errors?.locationAddress?.message}</span>
                  </div>
                  <Col xl="12" className="push-notification-footer">
                    <button
                      className="btn btn-primary"
                      type="button"
                      onClick={LargeModaltoggle}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      type="submit"
                      style={{ marginLeft: "20px" }}
                    >
                      Confirm
                    </button>
                  </Col>
                </Form>
              )
            }
          </>
        ) : (
          <>
            <Col xl="12" className="push-botification-body">
              <div className="text-center">Are you sure to end this trip manually ?</div>
            </Col>
            <Col xl="12" className="push-notification-footer">
              <button
                className="btn btn-primary"
                type="submit"
                onClick={LargeModaltoggle}
              >
                Cancel
              </button>
              <button
                className="btn btn-primary"
                type="submit"
                style={{ marginLeft: "20px" }}
                onClick={() => onClickConfirm()}
              >
                Confirm
              </button>
            </Col>
          </>
        )}
      </Row>
    </CommonModal>
  );
};

export default VendorEndTripConformation;
